import { render, staticRenderFns } from "./recordTable.vue?vue&type=template&id=187b9ef0&scoped=true"
import script from "./recordTable.vue?vue&type=script&lang=js"
export * from "./recordTable.vue?vue&type=script&lang=js"
import style0 from "./recordTable.vue?vue&type=style&index=0&id=187b9ef0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187b9ef0",
  null
  
)

export default component.exports